export default "__VITE_ASSET__WOi8_Nhh__"